module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/assets/plugins/fonts/glyphicons-halflings-regular.woff
// module id = ../../../../../src/assets/plugins/fonts/glyphicons-halflings-regular.woff
// module chunks = styles